import * as React from "react";
import { forwardRef } from "react";
const SvgIconArrowLeftWide = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 12, height: 14, viewBox: "0 0 8 14", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "m6.918 7.654-.376-.36L0 .752.752 0l6.166 6.166L13.084 0l.752.752-6.542 6.542z", "data-name": "Path 1192", transform: "rotate(90 4.827 4.828)", fill: "#98a9bc" }));
const ForwardRef = forwardRef(SvgIconArrowLeftWide);
export { ForwardRef as ReactComponent };
